// src/components/content/ContentContext.jsx
import React, { createContext, useEffect, useState } from "react";
import Cookies from 'js-cookie';
import '../../Forum.css';

export const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState("PostList");
  const [selectedPostId, setSelectedPostId] = useState(null);

  useEffect(() => {
    const postId = Cookies.get('postId');
    if (postId) {
      setSelectedPostId(postId);
    }

    const storedContent = Cookies.get('content');
    if (storedContent) {
      setContent(storedContent);
    }
  });

  const saveSelectedPostId = (postId) => {
    setSelectedPostId(postId);
    Cookies.set('postId', postId);
  }

  const saveContent = (content) => {
    setContent(content);
    Cookies.set('content', content);
  }


  return (
    <ContentContext.Provider value={{ content, setContent: saveContent, selectedPostId, setSelectedPostId:saveSelectedPostId }}>
      {children}
    </ContentContext.Provider>
  );
}

export default ContentProvider;
